import React from 'react'
import Grid from '@material-ui/core/Grid'
import { LevelCard } from '../components'
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { makeStyles } from '@material-ui/core/styles'
import { DataUsers } from '../types';
import { COLORS } from 'styles';

const useStyles = makeStyles({
    title: {
        color: COLORS.FONT,
    },
    divider: {
        backgroundColor: COLORS.BASE
    }
});

interface propsUsers {
    data: DataUsers
}

const Users: React.FC<propsUsers> = ({ data }) => {
    const classes = useStyles()

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h6" component="h2" className={classes.title}>
                    Usuarios
                </Typography>
                <Divider className={classes.divider} />
            </Grid>
            <Grid item xs={4}>
                <LevelCard
                    title="Usuarios Nivel 1"
                    totalValue={data.level_1}
                    totalValuePrevious={data.level_1_previous}
                    birthdayValue={data.level_1_birthday}
                    birthdayValuePrevious={data.level_1_birthday_previous}
                />
            </Grid>
            <Grid item xs={4}>
                <LevelCard
                    title="Usuarios Nivel 2"
                    totalValue={data.level_2}
                    totalValuePrevious={data.level_2_previous}
                    birthdayValue={data.level_2_birthday}
                    birthdayValuePrevious={data.level_2_birthday_previous}
                />
            </Grid>
            <Grid item xs={4}>
                <LevelCard
                    title="Usuarios Nivel 3"
                    totalValue={data.level_3}
                    totalValuePrevious={data.level_3_previous}
                    birthdayValue={data.level_3_birthday}
                    birthdayValuePrevious={data.level_3_birthday_previous}
                />
            </Grid>
        </>
    )
}

export { Users }

